export const parseLocaleOrLang = (localeOrLang) => {
    if (!localeOrLang.includes('-')) {
        return { lang: localeOrLang, country: undefined, locale: localeOrLang };
    }
    const [lang, country] = localeOrLang.split('-');
    return { lang, country, locale: localeOrLang };
};
//# sourceMappingURL=parse-locale.js.map